/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect } from "react";
import { loadWeb3, getWeb3Instance } from "./Connectivity/Connectivity";
import { toast } from "react-toastify";
import { tradeXNftRedeem, tradeXNftRedeemAbi } from "./Contract";
import "bootstrap/dist/css/bootstrap.min.css";

export default function NftRedeem() {
  const [btnTxt, setBtnTxt] = useState("Connect Wallet");
  const [account, setAccount] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [loadingStates, setLoadingStates] = useState({});
  const [functionInputs, setFunctionInputs] = useState({});
  const [functionOutputs, setFunctionOutputs] = useState({});
  const [tradexTokenAddress, setTradexTokenAddress] = useState("");

  const [overviewData, setOverviewData] = useState({
    paused: false,
    redeemBurnPercent: "",
    redeemCreatorPercent: "",
    redeemIncrementPercent: "",
    redeemLevelPercent: "",
    redeemOwnerPercent: "",
    owner: "",
    tradexToken: "",
    usdtToken: "",
  });

  const rewardFunctions = {
    readFunctions: [
      { name: "getTradexToUsdtPrice", title: "TradeX → USDT Price", description: "Get USDT value for given TradeX amount", inputs: [{ name: "tradexAmount", type: "uint256", placeholder: "TradeX amount (wei)", required: true }], icon: "💱", category: "Price Helpers", formatOutput: (v) => `${v.toString()} wei` },
      { name: "getUsdtToTradexPrice", title: "USDT → TradeX Price", description: "Get TradeX value for given USDT amount", inputs: [{ name: "usdtAmount", type: "uint256", placeholder: "USDT amount (wei)", required: true }], icon: "💱", category: "Price Helpers", formatOutput: (v) => `${v.toString()} wei` },
      { name: "redeemBurnPercent", title: "Burn Percent", description: "Percentage burned on redeem", inputs: [], icon: "🔥", category: "Redeem Percentages", formatOutput: (v) => `${v.toString()}` },
      { name: "redeemCreatorPercent", title: "Creator Percent", description: "Percentage sent to creator on redeem", inputs: [], icon: "🎨", category: "Redeem Percentages", formatOutput: (v) => `${v.toString()}` },
      { name: "redeemIncrementPercent", title: "Increment Percent", description: "Percentage incremented on redeem", inputs: [], icon: "📈", category: "Redeem Percentages", formatOutput: (v) => `${v.toString()}` },
      { name: "redeemLevelPercent", title: "Level Percent", description: "Percentage for level rewards on redeem", inputs: [], icon: "🏆", category: "Redeem Percentages", formatOutput: (v) => `${v.toString()}` },
      { name: "redeemOwnerPercent", title: "Owner Percent", description: "Percentage sent to owner on redeem", inputs: [], icon: "👑", category: "Redeem Percentages", formatOutput: (v) => `${v.toString()}` },
      { name: "lpReward", title: "LP Reward Contract", description: "Address of LP reward contract", inputs: [], icon: "💧", category: "Contract Addresses" },
      { name: "nftMatrixContract", title: "NFT Matrix Contract", description: "Address of NFT matrix contract", inputs: [], icon: "🤖", category: "Contract Addresses" },
      { name: "nftReward", title: "NFT Reward Contract", description: "Address of NFT reward contract", inputs: [], icon: "🎁", category: "Contract Addresses" },
      { name: "platformRewardReceiver", title: "Platform Reward Receiver", description: "Address that receives platform rewards", inputs: [], icon: "📤", category: "Contract Addresses" },
      { name: "router", title: "Uniswap Router", description: "Address of the Uniswap V2 router", inputs: [], icon: "🚀", category: "Contract Addresses" },
      { name: "tradexToken", title: "TradeX Token", description: "Address of TradeX ERC20 token", inputs: [], icon: "🪐", category: "Contract Addresses" },
      { name: "usdtToken", title: "USDT Token", description: "Address of USDT ERC20 token", inputs: [], icon: "💵", category: "Contract Addresses" },
      { name: "owner", title: "Owner", description: "Current contract owner address", inputs: [], icon: "👑", category: "Ownership & Status" },
      { name: "paused", title: "Paused", description: "Check if contract is paused", inputs: [], icon: "⏸️", category: "Ownership & Status", formatOutput: (v) => (v ? "Yes — Contract is PAUSED" : "No — Contract is ACTIVE") },
    ],
    writeFunctions: [
      { name: "redeemTradexToken", title: "Redeem TradeX Token", description: "Redeem TradeX tokens for USDT. Approval for TradeX is handled automatically.", inputs: [{ name: "tradexAmount", type: "uint256", placeholder: "TradeX amount (wei)", required: true }], requiresTradexApproval: true, icon: "🔄", category: "Redeem" },
    ],
    adminFunctions: [
      { name: "pause", title: "Pause Contract", description: "Pause all contract operations", inputs: [], icon: "⏸️", category: "Pause Control" },
      { name: "unpause", title: "Unpause Contract", description: "Resume contract operations", inputs: [], icon: "▶️", category: "Pause Control" },
      { name: "renounceOwnership", title: "Renounce Ownership", description: "Permanently renounce contract ownership", inputs: [], icon: "🚫", category: "Ownership" },
      { name: "transferOwnership", title: "Transfer Ownership", description: "Transfer ownership to a new address", inputs: [{ name: "newOwner", type: "address", placeholder: "New owner address", required: true }], icon: "🔄", category: "Ownership" },
      { name: "setLpRewardContract", title: "Set LP Reward Contract", description: "Update the LP reward contract address", inputs: [{ name: "newLpReward", type: "address", placeholder: "New LP reward address", required: true }], icon: "💧", category: "Admin Settings" },
      { name: "setNftMatrixContract", title: "Set NFT Matrix Contract", description: "Update the NFT matrix contract address", inputs: [{ name: "newMatrix", type: "address", placeholder: "New matrix address", required: true }], icon: "🤖", category: "Admin Settings" },
      { name: "setNftRewardContract", title: "Set NFT Reward Contract", description: "Update the NFT reward contract address", inputs: [{ name: "newReward", type: "address", placeholder: "New NFT reward address", required: true }], icon: "🎁", category: "Admin Settings" },
      { name: "setPlatformRewardReceiver", title: "Set Platform Reward Receiver", description: "Update the platform reward receiver address", inputs: [{ name: "newReceiver", type: "address", placeholder: "New receiver address", required: true }], icon: "📤", category: "Admin Settings" },
      { name: "setRedeemPercents", title: "Set Redeem Percents", description: "Set all redeem distribution percentages (must total correctly)", inputs: [ { name: "newIncrementPercent", type: "uint256", placeholder: "Increment percent", required: true }, { name: "newOwnerPercent", type: "uint256", placeholder: "Owner percent", required: true }, { name: "newLevelPercent", type: "uint256", placeholder: "Level percent", required: true }, { name: "newCreatorPercent", type: "uint256", placeholder: "Creator percent", required: true }, { name: "newBurnPercent", type: "uint256", placeholder: "Burn percent", required: true }, ], icon: "📊", category: "Admin Settings" },
      { name: "setRouter", title: "Set Router", description: "Update the Uniswap V2 router address", inputs: [{ name: "newRouter", type: "address", placeholder: "New router address", required: true }], icon: "🚀", category: "Admin Settings" },
      { name: "setTradexToken", title: "Set TradeX Token", description: "Update the TradeX ERC20 token address", inputs: [{ name: "newToken", type: "address", placeholder: "New TradeX token address", required: true }], icon: "🪐", category: "Admin Settings" },
      { name: "setUsdtToken", title: "Set USDT Token", description: "Update the USDT ERC20 token address", inputs: [{ name: "newToken", type: "address", placeholder: "New USDT token address", required: true }], icon: "💵", category: "Admin Settings" },
      { name: "recoverErc20", title: "Recover ERC20", description: "Recover any ERC20 token stuck in the contract", inputs: [{ name: "token", type: "address", placeholder: "Token address", required: true }, { name: "amount", type: "uint256", placeholder: "Amount (wei)", required: true }], icon: "🔄", category: "Admin Recovery" },
      { name: "initialize", title: "Initialize", description: "Initialize the contract with core addresses (admin only)", inputs: [{ name: "initialOwner", type: "address", placeholder: "Initial owner address", required: true }, { name: "newNftMatrix", type: "address", placeholder: "NFT Matrix contract address", required: true }, { name: "newNftReward", type: "address", placeholder: "NFT Reward contract address", required: true }, { name: "newLpReward", type: "address", placeholder: "LP Reward contract address", required: true }, { name: "newPlatformRewardReceiver", type: "address", placeholder: "Platform reward receiver address", required: true }], icon: "⚙️", category: "Admin Control" },
      { name: "newSetUp", title: "New Setup", description: "Re-apply setup configuration (admin only)", inputs: [], icon: "🔧", category: "Admin Control" },
    ],
  };

  const connectWallet = async () => {
    setLoadingStates((prev) => ({ ...prev, connect: true }));
    try {
      const acc = await loadWeb3();
      if (acc === "No Wallet") {
        toast.error("No Wallet Detected");
        setBtnTxt("Connect Wallet");
      } else if (acc === "Wrong Network") {
        toast.error("Please switch to correct Network");
        setBtnTxt("Wrong Network");
      } else {
        setAccount(acc);
        setBtnTxt(acc.substring(0, 6) + "..." + acc.substring(acc.length - 4));
        toast.success("Wallet Connected!");
        loadOverviewData();
      }
    } catch (error) {
      console.error("Connection error:", error);
      toast.error("Connection failed");
      setBtnTxt("Connect Wallet");
    } finally {
      setLoadingStates((prev) => ({ ...prev, connect: false }));
    }
  };

  const getContract = () => {
    const web3 = getWeb3Instance();
    return new web3.eth.Contract(tradeXNftRedeemAbi, tradeXNftRedeem);
  };

  const ERC20_ABI = [
    { inputs: [{ internalType: "address", name: "spender", type: "address" }, { internalType: "uint256", name: "amount", type: "uint256" }], name: "approve", outputs: [{ internalType: "bool", name: "", type: "bool" }], stateMutability: "nonpayable", type: "function" },
    { inputs: [{ internalType: "address", name: "owner", type: "address" }, { internalType: "address", name: "spender", type: "address" }], name: "allowance", outputs: [{ internalType: "uint256", name: "", type: "uint256" }], stateMutability: "view", type: "function" },
  ];

  const getTokenContract = (address) => {
    const web3 = getWeb3Instance();
    return new web3.eth.Contract(ERC20_ABI, address);
  };

  const loadOverviewData = useCallback(async () => {
    if (!account) return;
    try {
      const contract = getContract();
      const safeCall = async (methodName, fallback = "0") => {
        try {
          if (typeof contract.methods[methodName] === 'function') {
            return await contract.methods[methodName]().call();
          }
          return fallback;
        } catch (e) {
          return fallback;
        }
      };

      const paused = await safeCall("paused", false);
      const burnPct = await safeCall("redeemBurnPercent", "0");
      const creatorPct = await safeCall("redeemCreatorPercent", "0");
      const incrementPct = await safeCall("redeemIncrementPercent", "0");
      const levelPct = await safeCall("redeemLevelPercent", "0");
      const ownerPct = await safeCall("redeemOwnerPercent", "0");
      const ownerAddr = await safeCall("owner", "");
      const tradexAddr = await safeCall("tradexToken", "");
      const usdtAddr = await safeCall("usdtToken", "");

      setTradexTokenAddress(tradexAddr);
      setOverviewData({
        paused, redeemBurnPercent: burnPct.toString(), redeemCreatorPercent: creatorPct.toString(),
        redeemIncrementPercent: incrementPct.toString(), redeemLevelPercent: levelPct.toString(),
        redeemOwnerPercent: ownerPct.toString(), owner: ownerAddr, tradexToken: tradexAddr, usdtToken: usdtAddr,
      });
    } catch (error) {
      console.error("Error loading overview data:", error);
      toast.error("Failed to load contract data");
    }
  }, [account]);

  useEffect(() => {
    if (account) loadOverviewData();
  }, [account, loadOverviewData]);

  const handleInputChange = (functionName, inputName, value) => {
    setFunctionInputs((prev) => ({ ...prev, [functionName]: { ...prev[functionName], [inputName]: value } }));
  };

  const executeReadFunction = async (functionData) => {
    if (!account) { toast.error("Please connect your wallet first"); return; }
    const funcKey = functionData.name;
    setLoadingStates((prev) => ({ ...prev, [funcKey]: true }));
    try {
      const contract = getContract();
      const inputs = functionInputs[funcKey] || {};
      const args = functionData.inputs.map((input) => {
        const value = inputs[input.name];
        if (input.required && (!value || value.trim() === "")) throw new Error(`${input.name} is required`);
        return value || "";
      });
      const result = await contract.methods[functionData.name](...args).call();
      const formatted = functionData.formatOutput ? functionData.formatOutput(result) : JSON.stringify(result, (k, v) => (typeof v === "bigint" ? v.toString() : v), 2);
      setFunctionOutputs((prev) => ({ ...prev, [funcKey]: formatted }));
      toast.success("Read successful!");
    } catch (error) {
      console.error("Read error:", error);
      toast.error(error.message || "Read operation failed");
    } finally { setLoadingStates((prev) => ({ ...prev, [funcKey]: false })); }
  };

  const executeWriteFunction = async (functionData) => {
    if (!account) { toast.error("Please connect your wallet first"); return; }
    const funcKey = functionData.name;
    setLoadingStates((prev) => ({ ...prev, [funcKey]: true }));
    try {
      const contract = getContract();
      const inputs = functionInputs[funcKey] || {};
      const args = functionData.inputs.map((input) => {
        const value = inputs[input.name];
        if (input.required && (!value || value.trim() === "")) throw new Error(`${input.name} is required`);
        if (input.type === "bool") return value.toLowerCase() === "true";
        return value || "";
      });
      if (functionData.requiresTradexApproval && tradexTokenAddress) {
        const tradexAmount = args[0];
        const tokenContract = getTokenContract(tradexTokenAddress);
        const allowance = await tokenContract.methods.allowance(account, tradeXNftRedeem).call();
        if (BigInt(allowance) < BigInt(tradexAmount)) {
          toast.info("Approving TradeX token...");
          await tokenContract.methods.approve(tradeXNftRedeem, tradexAmount).send({ from: account });
          toast.success("TradeX Approved!");
        }
      }
      const tx = await contract.methods[functionData.name](...args).send({ from: account });
      toast.success(`✅ Tx successful! ${tx.transactionHash.substring(0, 18)}...`);
      loadOverviewData();
    } catch (error) {
      console.error("Write error:", error);
      toast.error(error.message || "Transaction failed");
    } finally { setLoadingStates((prev) => ({ ...prev, [funcKey]: false })); }
  };

  const groupByCategory = (functions) => functions.reduce((acc, func) => {
    const cat = func.category || "Other";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(func);
    return acc;
  }, {});

  const renderFunctionCard = (func, isWrite = false) => {
    const funcKey = func.name;
    const inputs = functionInputs[funcKey] || {};
    const output = functionOutputs[funcKey];
    const isLoading = loadingStates[funcKey] || false;
    const btnGradient = isWrite ? "linear-gradient(135deg, #ff6b6b, #4ecdc4)" : "linear-gradient(135deg, #00ff88, #00ccff)";

    return (
      <div key={funcKey} className="col-lg-4 col-md-6 mb-4">
        <div className="card h-100 shadow-lg border-0" style={{ borderRadius: "20px", background: "linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))", backdropFilter: "blur(15px)", border: "1px solid rgba(255,255,255,0.1)" }}>
          <div className="card-body p-4 d-flex flex-column">
            <div className="d-flex align-items-center mb-3">
              <span className="fs-3 me-3">{func.icon}</span>
              <div>
                <h6 className="mb-1 text-white fw-bold">{func.title}</h6>
                <small className="text-white-50">{func.description}</small>
              </div>
            </div>
            {func.inputs.map((input) => (
              <div key={input.name} className="mb-2">
                <input 
                  type="text" 
                  className="form-control bg-dark border-0 text-white custom-placeholder" 
                  placeholder={input.placeholder} 
                  value={inputs[input.name] || ""} 
                  onChange={(e) => handleInputChange(funcKey, input.name, e.target.value)} 
                  style={{ borderRadius: "12px", padding: "10px 14px" }} 
                />
              </div>
            ))}
            <button onClick={() => isWrite ? executeWriteFunction(func) : executeReadFunction(func)} disabled={isLoading} className="btn w-100 mt-auto" style={{ background: isLoading ? "rgba(255,255,255,0.1)" : btnGradient, border: "none", color: "#fff", borderRadius: "12px", padding: "11px", fontWeight: "600", fontSize: "0.9rem" }}>
              {isLoading ? <span><span className="spinner-border spinner-border-sm me-2" role="status" />Processing...</span> : isWrite ? "⚡ Execute" : "🔍 Read"}
            </button>
            {output !== undefined && output !== null && output !== "" && (
              <div className="mt-3 p-3 rounded-3" style={{ background: "rgba(0,255,136,0.08)", border: "1px solid rgba(0,255,136,0.25)", maxHeight: "180px", overflowY: "auto" }}>
                <small className="text-white-50 d-block mb-1">Output:</small>
                {/* Yahan text-white kar diya gaya hai */}
                <code className="text-white" style={{ fontSize: "0.85rem", wordBreak: "break-all" }}>{output}</code>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const tabs = [
    { key: "overview", label: "Overview", icon: "🏪", color: "#00ff88" },
    { key: "read", label: "Read Functions", icon: "👁️", color: "#45b7d1" },
    { key: "write", label: "Write Functions", icon: "📝", color: "#4ecdc4" },
    { key: "admin", label: "Admin Functions", icon: "⚙️", color: "#ff6b6b" },
  ];

  const overviewCards = [
    { label: "Contract Status", value: overviewData.paused ? "PAUSED" : "ACTIVE", icon: overviewData.paused ? "⏸️" : "▶️", color: overviewData.paused ? "#ff6b6b" : "#00ff88" },
    { label: "Burn Percent", value: overviewData.redeemBurnPercent || "—", icon: "🔥", color: "#ff6b6b" },
    { label: "Creator Percent", value: overviewData.redeemCreatorPercent || "—", icon: "🎨", color: "#f7d774" },
    { label: "Increment Percent", value: overviewData.redeemIncrementPercent || "—", icon: "📈", color: "#45b7d1" },
    { label: "Level Percent", value: overviewData.redeemLevelPercent || "—", icon: "🏆", color: "#4ecdc4" },
    { label: "Owner Percent", value: overviewData.redeemOwnerPercent || "—", icon: "👑", color: "#a78bfa" },
  ];

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4" style={{ background: "linear-gradient(135deg, #000428, #004e92)" }}>
      {/* Yeh style tag specifically placeholders ko white/visible karne ke liye add kiya hai */}
      <style>{`
        .custom-placeholder::placeholder {
          color: rgba(255, 255, 255, 0.6) !important;
        }
      `}</style>

      <div className="container text-center">
        <h1 className="mb-2 display-5 fw-bold" style={{ background: "linear-gradient(135deg, #00ff88, #00ccff)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
          TradeX NFT Redeem Dashboard
        </h1>
        <p className="text-white-50 mb-4">TradeX Token Redeem Reward Contract Interface</p>

        <div className="mb-4">
          <button
            onClick={connectWallet}
            disabled={loadingStates.connect}
            className="btn px-4 px-md-5 py-3 rounded-pill shadow-lg position-relative overflow-hidden"
            style={{ background: account ? 'linear-gradient(135deg, #00ff88, #00ccff)' : 'linear-gradient(135deg, #ff6b6b, #4ecdc4)', border: 'none', color: account ? '#000' : '#fff', fontSize: 'clamp(0.9rem, 3vw, 1.1rem)', fontWeight: '700', transition: 'all 0.3s ease', minWidth: '160px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', opacity: loadingStates.connect ? 0.7 : 1 }}
          >
            {loadingStates.connect ? (
              <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                Connecting...
              </div>
            ) : (
              <span className="position-relative">{btnTxt}</span>
            )}
          </button>
        </div>

        {account && (
          <div className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-4" style={{ background: "rgba(0,255,136,0.1)", border: "1px solid rgba(0,255,136,0.3)" }}>
            <span className="text-white-50 small">🔗 {account.substring(0, 6)}...{account.substring(account.length - 4)}</span>
            <span className="badge bg-success rounded-pill">Connected</span>
          </div>
        )}

        {account && (
          <div className="card shadow-lg border-0" style={{ borderRadius: "24px", background: "rgba(255,255,255,0.05)", backdropFilter: "blur(20px)", border: "1px solid rgba(255,255,255,0.1)" }}>
            <div className="card-header border-0 p-4" style={{ borderRadius: "24px 24px 0 0", background: "transparent" }}>
              <ul className="nav nav-pills justify-content-center flex-wrap gap-2">
                {tabs.map((tab) => (
                  <li key={tab.key} className="nav-item">
                    <button className={`nav-link border-0 px-4 py-2 fw-bold ${activeTab === tab.key ? "text-dark" : "text-white-50"}`} onClick={() => setActiveTab(tab.key)} style={{ borderRadius: "14px", background: activeTab === tab.key ? `linear-gradient(135deg, ${tab.color}, ${tab.color}80)` : "rgba(255,255,255,0.05)", border: activeTab === tab.key ? `1px solid ${tab.color}` : "1px solid rgba(255,255,255,0.1)", transition: "all 0.3s ease", transform: activeTab === tab.key ? "translateY(-2px)" : "none", boxShadow: activeTab === tab.key ? `0 6px 20px ${tab.color}40` : "none" }}>
                      <span className="me-2">{tab.icon}</span>
                      <span className="d-none d-sm-inline">{tab.label}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="card-body p-4" style={{ background: "rgba(0,0,0,0.2)", borderRadius: "0 0 24px 24px" }}>
              {activeTab === "overview" && (
                <div>
                  <div className="row g-3 mb-4">
                    {overviewCards.map((card) => (
                      <div key={card.label} className="col-lg-2 col-md-4 col-6">
                        <div className="card border-0 h-100" style={{ borderRadius: "18px", background: `linear-gradient(135deg, ${card.color}20, ${card.color}08)`, border: `1px solid ${card.color}40` }}>
                          <div className="card-body p-3 text-center">
                            <div className="fs-2 mb-2">{card.icon}</div>
                            <h5 className="fw-bold mb-1" style={{ color: card.color, fontSize: "1.1rem" }}>{card.value}</h5>
                            <p className="text-white-50 mb-0" style={{ fontSize: "0.75rem" }}>{card.label}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="p-3 rounded-4 text-start" style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)" }}>
                    <h6 className="text-white-50 mb-3">📋 Contract Addresses</h6>
                    <div className="row g-2">
                      {[{ label: "Owner", value: overviewData.owner }, { label: "TradeX Token", value: overviewData.tradexToken }, { label: "USDT Token", value: overviewData.usdtToken }].map((item) => (
                        <div key={item.label} className="col-md-4">
                          <div className="p-2 rounded-3" style={{ background: "rgba(0,0,0,0.3)" }}>
                            <small className="text-white-50 d-block">{item.label}</small>
                            <code className="text-info" style={{ fontSize: "0.75rem", wordBreak: "break-all" }}>{item.value || "Loading..."}</code>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="mt-3 text-end">
                      <button className="btn btn-sm" onClick={loadOverviewData} style={{ background: "rgba(0,255,136,0.15)", border: "1px solid #00ff88", color: "#00ff88", borderRadius: "10px" }}>🔄 Refresh All</button>
                    </div>
                  </div>
                </div>
              )}
              {activeTab === "read" && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4"><h5 className="mb-0 text-info">👁️ Read Functions</h5><small className="text-white-50">{rewardFunctions.readFunctions.length} functions</small></div>
                  {Object.entries(groupByCategory(rewardFunctions.readFunctions)).map(([category, funcs]) => (<div key={category} className="mb-5"><h6 className="mb-3 d-flex align-items-center gap-2 text-white-50">{category}<span className="badge bg-secondary">{funcs.length}</span></h6><div className="row">{funcs.map((func) => renderFunctionCard(func, false))}</div></div>))}
                </div>
              )}
              {activeTab === "write" && (
                <div>
                  <h5 className="mb-4" style={{ color: "#4ecdc4" }}>📝 Write Functions</h5>
                  {Object.entries(groupByCategory(rewardFunctions.writeFunctions)).map(([category, funcs]) => (<div key={category} className="mb-5"><h6 className="mb-3 text-white-50">{category}</h6><div className="row">{funcs.map((func) => renderFunctionCard(func, true))}</div></div>))}
                </div>
              )}
              {activeTab === "admin" && (
                <div>
                  <h5 className="mb-3 text-danger">⚙️ Admin Functions</h5>
                  <div className="alert mb-4 text-start" style={{ background: "rgba(255,107,107,0.1)", border: "1px solid rgba(255,107,107,0.4)", borderRadius: "14px", color: "#ffaaaa" }}><strong>⚠️ Warning:</strong> These functions are restricted to the contract owner only.</div>
                  {Object.entries(groupByCategory(rewardFunctions.adminFunctions)).map(([category, funcs]) => (<div key={category} className="mb-5"><h6 className="mb-3 text-white-50">{category}</h6><div className="row">{funcs.map((func) => renderFunctionCard(func, true))}</div></div>))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

